import { useMemo } from "react";

export default function useColumnsProductPurchases() {
 const columns = useMemo(
   () => [
     {
       Header: "ID",
       accessor: "_id"
     },
     {
       Header: "ID",
       accessor: "id"
     },
     {
      Header: "Producto",
      accessor: "name"
     }, 
     {
       Header: "Fecha",
       accessor: "date"
     }, 
     {
       Header: "Fecha No View",
       accessor: "dateNoView"
     },
     {
       Header: "Proveedor",
       accessor: "supplier"
     },
     {
       Header: "N° de Comprobante",
       accessor: "invoiceNumber"
     },
     {
        Header: "Tipo de comprobante",
        accessor: "invoiceLetter"
     },
     {
       Header: "Cantidad",
       accessor: "quantity"
     },
     {
       Header: "Precio Unitario",
       accessor: "unitPrice"
     },
     {
       Header: "I.V.A.",
       accessor: "avgIva"
     },
     {
       Header: "Precio total",
       accessor: "totalPrice"
     }
   ],
   []
 );

 return columns;
}